import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'

import { PageTitle } from '../../../components/PageTitle'
import BannerPage from './Banners/BannerPage'
import WebsiteFontsPage from './Fonts/WebsiteFontsPage'
import { SidebarBannerPage } from './SidebarBanner/SidebarBannerPage'
import { useBannerFonts } from './useBannerFonts'

const BannersPage = () => {
  const bannerFonts = useBannerFonts()

  return (
    <>
      <PageTitle title="Gerenciamento de Banners" description="Banners exibidos no site e na sidebar" />
      <Tabs isLazy lazyBehavior="keepMounted">
        <TabList>
          <Tab>Banner Lateral</Tab>
          <Tab>Banners Home</Tab>
          <Tab>Fontes</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <SidebarBannerPage />
          </TabPanel>
          <TabPanel>
            <BannerPage bannerFonts={bannerFonts} />
          </TabPanel>
          <TabPanel>
            <WebsiteFontsPage bannerFonts={bannerFonts} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  )
}

export default BannersPage
